module.exports = __webpack_public_path__ + "img/taoambro2.dc3a669f.jpeg";